import { render, staticRenderFns } from "./SmsTemplateSelectionModal.vue?vue&type=template&id=6884b6b5&scoped=true"
import script from "./SmsTemplateSelectionModal.vue?vue&type=script&lang=js"
export * from "./SmsTemplateSelectionModal.vue?vue&type=script&lang=js"
import style0 from "./SmsTemplateSelectionModal.vue?vue&type=style&index=0&id=6884b6b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6884b6b5",
  null
  
)

export default component.exports